export const links = [
    {
        text: "Rijnland Duurzaam en Circulair",
        description: "Hoogheemraadschap Rijnland zet samen met de omgeving in op duurzaam werken en op het sluitend maken van de kringloop van water, energie en grondstoffen.",
        to: "https://wbp6rijnland.nl/het-programma/rijnland-duurzaam-en-circulair"
    },
    {
        text: "Unie van Waterschappen - Circulaire Economie",
        description: "Uitleg van het perspectief van de Unie van Waterschappen over de Circulaire Economie.",
        to: "https://unievanwaterschappen.nl/themas/circulaire-economie/"
    }
];
